import { makeStyles } from "@mui/styles";

const useStyles = makeStyles({
    welcome: {
        height: '10rem',
        margin: '2rem',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center'
    }
})

export default useStyles